export default __webpack_public_path__ + "images/95a6adefee275bc70102db79d1c78c71.svg";